<template>
    <div
        class="t-menu menu"
    >
        <slot name="modal" />
        <slot name="header"/>
        <slot name="main" />
        <slot name="footer" />
    </div>
</template>

<script>

export default {
    name: 'TMenu'
}
</script>

<style lang="scss">
@import "t-menu";
</style>
